import { SvgIcon, SvgIconProps } from '@mui/material'

const ChartLineIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon role="img" viewBox="0 0 24 24" {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M3 2.25C3.41421 2.25 3.75 2.58579 3.75 3V20.25H21C21.4142 20.25 21.75 20.5858 21.75 21C21.75 21.4142 21.4142 21.75 21 21.75H3C2.58579 21.75 2.25 21.4142 2.25 21V3C2.25 2.58579 2.58579 2.25 3 2.25Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M21.3224 2.32279C21.6963 2.50087 21.8551 2.9484 21.6771 3.32238L16.6771 13.8224C16.5753 14.0361 16.3787 14.1892 16.1466 14.2355C15.9144 14.2817 15.6741 14.2157 15.4982 14.0574L11.2303 10.2163L7.67074 17.3353C7.4855 17.7058 7.03499 17.856 6.66451 17.6708C6.29403 17.4855 6.14386 17.035 6.3291 16.6645L10.3291 8.66452C10.4338 8.4551 10.6303 8.3066 10.8604 8.26303C11.0904 8.21946 11.3276 8.28583 11.5016 8.44246L15.7548 12.2703L20.3228 2.67748C20.5009 2.3035 20.9484 2.1447 21.3224 2.32279Z" fill="currentColor" />
    </SvgIcon>
  )
}

export default ChartLineIcon
